import ErrorHandler from '@schachermayer/sch-vuejs-commons/src/errors';
import { Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import { QuickLinksApi } from '../../../build/swagger-code-extranet-api-definition';
import { QuickLink } from '../../../build/swagger-code-extranet-api-definition/models';
import { QUICK_LINK_COLORS } from '../../constants';

const quickLinksApi: QuickLinksApi = new QuickLinksApi({ basePath: process.env.VUE_APP_CONTEXT_BASE });

@Module({
    namespaced: true,
    name: 'quickLinks',
})
export default class QuickLinksStoreModule extends VuexModule {
    public items: QuickLink[] = [];
    public colors: string[] = QUICK_LINK_COLORS;

    public hasBudgetOrdersPermission: boolean = false;
    public budgetOrdersCount: number = 0;

    @Mutation
    setHasBudgetOrdersPermission(hasBudgetOrdersPermission: boolean) {
        this.hasBudgetOrdersPermission = hasBudgetOrdersPermission;
    }

    @Mutation
    setBudgetOrdersCount(budgetOrdersCount: number) {
        this.budgetOrdersCount = budgetOrdersCount;
    }

    @Mutation
    setQuickLinks(items: QuickLink[]) {
        this.items = items;
    }

    @MutationAction({ mutate: ['items'], rawError: true })
    async loadQuickLinks() {
        try {
            const quickLinkItems: QuickLink[] = (await quickLinksApi.getQuickLinks({ credentials: 'same-origin' })).data;

            return { items: quickLinkItems };
        } catch (error) {
            ErrorHandler.handleError(error);
            return { items: [] };
        }
    }
}
